Oskari.bundle_manager.registerDynamic('seutumassa-landmass-tool', function() {return import(/* webpackChunkName: "chunk_seutumassa-landmass-tool" */ 'oskari-loader!/app/frontend/packages/seutumassa-landmass-tool/bundle.js');});
